<script lang="ts" setup>
import { computed } from 'vue'
import ColoredBadge from '../display/ColoredBadge.vue'
import type { ContainerBadgeInfo } from '~/models/containers'
import { useGlobalTagDialog } from '~/compositions/useTagDialog'
import { useContainerStore } from '~/stores/containers'

const props = defineProps<{
  badge: ContainerBadgeInfo
  containerNumber?: string
}>()

const { openTagDialog } = useGlobalTagDialog()
const containerStore = useContainerStore()

const isTagBadge = computed(() => props.badge.isTag === true)

function onClick(event: Event) {
  // Check if this is a tag badge and we have a container number
  if (isTagBadge.value && props.containerNumber) {
    event.stopPropagation()

    containerStore.clearContainerSelection()
    containerStore.toggleContainerSelection(props.containerNumber)

    openTagDialog([props.containerNumber])
    return
  }

  if (props.badge.link) {
    const url = props.badge.link
    window.open(url, '_blank')
  }
}
</script>

<template>
  <ColoredBadge
    :key="props.badge.message"
    v-tooltip="props.badge.tooltip"
    :type="props.badge.type"
    class="mr-2"
    :class="{
      'cursor-pointer': isTagBadge || props.badge.link,
      'hover:opacity-80': isTagBadge,
    }"
    @click="onClick"
  >
    {{ props.badge.message }}
  </ColoredBadge>
</template>
